import { Controller } from "@hotwired/stimulus"

// In order to use multiple InputFilterController instances on the same page you
// have two options to avoid target and value conflicts:
//    - Use Stimulus Controller Scope rules, if there are no overlaps in targets.
//    - Create a new controller that inheirits from this class to avoid the controller name conflict (see app/grant_filter_controller.js)
//
// Connects to data-controller="input-filter"
export default class extends Controller {

	static targets = [
		'input',
		'hide',
		'remove',
		'destroy',
		'uncheck',
	]

	static values = {
		attributeName: String,
		comparison: String,
	}

	static outlets = [ 'choices' ]

	connect() {
		this.comparisonLambda = this.getComparisonLambda()
		const inputValue = this.inputTarget.value
		if (inputValue && inputValue != '') this.performUpdate(Number.parseInt(inputValue))
	}

	updateFilterables(event) {
		this.performUpdate(Number.parseInt(event.currentTarget.value))
	}

	performUpdate(value) {
		this.updateHides   (value)
		this.updateRemoves (value)
		this.updateDestroys(value)
		this.updateUnchecks(value)
		this.updateOutlets (value)
	}

	updateHides(value) {
		this.hideTargets.forEach(element => {
			const elementValues = JSON.parse(element.dataset[this.attributeNameValue])

			if (elementValues.length == 0 || this.comparisonLambda(elementValues, value)) {
				element.classList.remove('d-none')
			} else {
				element.classList.add('d-none')
			}
		})
	}

	updateRemoves(value) {
		this.removeTargets.forEach(element => {
			const elementValues = JSON.parse(element.dataset[this.attributeNameValue])

			if (elementValues.length > 0 && !this.comparisonLambda(elementValues, value)) {
				element.remove()
			}
		})
	}

	updateDestroys(value) {
		this.destroyTargets.forEach(element => {
			const elementValues = JSON.parse(element.dataset[this.attributeNameValue])

			if (elementValues.length > 0 && !this.comparisonLambda(elementValues, value)) {
				element.dispatchEvent(new Event('markToDestroy'))
			}
		})
	}

	updateUnchecks(value) {
		this.uncheckTargets.forEach(element => {
			const elementValues = JSON.parse(element.dataset[this.attributeNameValue])

			if (elementValues.length > 0 && !this.comparisonLambda(elementValues, value)) {
				element.classList.add('d-none')
				element.querySelector('[type="checkbox"]').checked = false
			} else {
				element.classList.remove('d-none')
			}
		})
	}

	updateOutlets(value) {
		this.choicesOutlets.forEach(outlet => {
			outlet.updateChoicesFromInputFilter(this.attributeNameValue, Number.parseInt(value), this.comparisonLambda)
		})
	}

	getComparisonLambda() {
		switch (this.comparisonValue) {
			case '=':
				return (x,y) => x == y
				break;
			case 'index':
				return (x,y) => x.indexOf(y) >= 0
				break;
		}
	}
}
